export default __webpack_public_path__ + "static/media/IG.be4d9fbc.svg";